module.exports = __webpack_public_path__ + "static/media/manzate_max.946e0073.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/tomate/climasense/tizon_tardio_tomate/curativa/manzate_max.png
// module id = 2399
// module chunks = 3